export enum HorizontalNavigationButtonDirection {
  LEFT,
  RIGHT,
}
